import { leaveDetailConstants } from "../constant/leaveDatail.constants";

export const initialState = {
    leaveDetail: [],
    isloading: false,
};
const leaveDetailReducer = (state = initialState, action) => {
    switch (action.type) {
        case leaveDetailConstants.GET_SUCCESS:
            return {
                ...state,
                leaveDetail: action.leaveDetail,
                isloading: true,
            };
        case leaveDetailConstants.GET_LIST_DETAIL:
            return {
                ...state,
                isloading: false,
            };
        default:
            return {
                ...state,
            };
    }
};

export default leaveDetailReducer;
